<script lang="ts" setup>
import type {CSSProperties} from 'vue';

const {emit} = useEventBus()
const simpleEmit = defineEmits(['onClose'])

const props = defineProps({
  id: String,
  style: {type: Object as () => CSSProperties, required: false},
  title: {type: String, required: false},
});
const open = () => {
  emit(`open-modal`, props.id)
}
const close = () => {
  emit(`close-modal`, props.id)
  simpleEmit('onClose')
}
</script>

<template>
  <div>
    <div class="modal fade" :id="id" data-bs-keyboard="false" data-bs-backdrop="static">
      <div class="modal-dialog modal-lg modal-dialog-centered p-2 my-0 mx-auto" :style="style" role="document">
        <div class="modal-content">
          <div v-if="title" class="modal-header" style="border-bottom: 0">
            <h4 class="modal-title">{{ title }}</h4>
            <button type="button" @click="close" class="btn-close" :data-bs-target="`#${id}`"
                    data-bs-dismiss="modal" aria-label="Fechar"></button>
          </div>
          <div class="modal-body p-0">
            <button v-if="!title" type="button" @click="close" class="btn-close float-end m-3" :data-bs-target="`#${id}`"
                    data-bs-dismiss="modal" aria-label="Fechar"></button>
            <slot/>
          </div>
        </div>
      </div>
    </div>
    <!-- GF usado no composables/useModal.ts para abrir e fechar a modal sem precisar importar bootstrap.Modal   -->
    <button v-show="false" :id="`open-${id}`" type="button" class="btn btn-secondary" :data-bs-target="`#${id}`"
            data-bs-toggle="modal" @click="open" data-bs-keyboard="false" data-bs-backdrop="static">Open
    </button>
    <button v-show="false" :id="`close-${id}`" @click="close" type="button" class="btn btn-secondary"
            :data-bs-target="`#${id}`"
            data-bs-dismiss="modal">Close
    </button>
  </div>
</template>
